var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeofence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_922_23996)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_922_23996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H27V27H13V13Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_922_23996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14.75C17.1055 14.75 14.75 17.1055 14.75 20C14.75 22.8945 17.1055 25.25 20 25.25C22.8945 25.25 25.25 22.8945 25.25 20C25.25 17.1055 22.8945 14.75 20 14.75ZM20 22.9167C18.3917 22.9167 17.0833 21.6082 17.0833 20C17.0833 18.3917 18.3917 17.0833 20 17.0833C21.6082 17.0833 22.9167 18.3917 22.9167 20C22.9167 21.6082 21.6082 22.9167 20 22.9167Z",
    fill: "url(#paint1_linear_922_23996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.6667C18.7132 17.6667 17.6667 18.7132 17.6667 20C17.6667 21.2869 18.7132 22.3334 20 22.3334C21.2869 22.3334 22.3334 21.2869 22.3334 20C22.3334 18.7132 21.2869 17.6667 20 17.6667Z",
    fill: "url(#paint2_linear_922_23996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2774 15.4109C25.2366 15.3637 25.1817 15.3316 25.1211 15.3176C24.9029 15.2686 24.7308 15.0965 24.6818 14.8783C24.6684 14.8177 24.6357 14.7628 24.5885 14.722C23.3133 13.6113 21.6835 13 20 13C18.3165 13 16.6867 13.6113 15.4109 14.7226C15.3637 14.7634 15.3316 14.8182 15.3176 14.8789C15.2686 15.0965 15.0965 15.2686 14.8783 15.3176C14.8177 15.331 14.7628 15.3637 14.722 15.4109C13.6113 16.6867 13 18.3165 13 20C13 21.6835 13.6113 23.3133 14.7226 24.5891C14.7634 24.6363 14.8182 24.6684 14.8789 24.6824C15.0971 24.7314 15.2692 24.9035 15.3182 25.1217C15.3316 25.1823 15.3642 25.2372 15.4115 25.278C16.6867 26.3887 18.3165 27 20 27C21.6835 27 23.3133 26.3887 24.5891 25.2774C24.6363 25.2366 24.6684 25.1817 24.6824 25.1211C24.7314 24.9029 24.9035 24.7308 25.1217 24.6818C25.1823 24.6684 25.2372 24.6357 25.278 24.5885C26.3887 23.3133 27 21.6835 27 20C27 18.3165 26.3887 16.6867 25.2774 15.4109ZM20 25.8333C16.7835 25.8333 14.1667 23.2165 14.1667 20C14.1667 16.7835 16.7835 14.1667 20 14.1667C23.2165 14.1667 25.8333 16.7835 25.8333 20C25.8333 23.2165 23.2165 25.8333 20 25.8333Z",
    fill: "url(#paint3_linear_922_23996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5417 14.75C25.4658 14.75 25.39 14.7208 25.3375 14.6683C25.2792 14.61 25.25 14.5341 25.25 14.4583C25.25 14.3825 25.2792 14.3066 25.3375 14.2541C25.4425 14.1433 25.6408 14.1433 25.7458 14.2541C25.8042 14.3066 25.8333 14.3825 25.8333 14.4583C25.8333 14.5341 25.8042 14.61 25.7458 14.6625C25.6933 14.7208 25.6175 14.75 25.5417 14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4584 14.75C14.3825 14.75 14.3125 14.7208 14.2542 14.6683C14.1959 14.61 14.1667 14.5341 14.1667 14.4583C14.1667 14.3825 14.1959 14.3066 14.2542 14.2541C14.3592 14.1433 14.5575 14.1433 14.6625 14.2541C14.7209 14.3125 14.75 14.3825 14.75 14.4583C14.75 14.5341 14.7209 14.61 14.6684 14.6625C14.61 14.7208 14.5342 14.75 14.4584 14.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4584 25.8334C14.3825 25.8334 14.3067 25.8042 14.2542 25.7459C14.1959 25.6934 14.1667 25.6175 14.1667 25.5417C14.1667 25.4659 14.1959 25.39 14.2542 25.3375C14.365 25.2267 14.5575 25.2267 14.6625 25.3375C14.7209 25.39 14.75 25.4659 14.75 25.5417C14.75 25.6175 14.7209 25.6934 14.6625 25.7459C14.61 25.8042 14.5342 25.8334 14.4584 25.8334Z",
    fill: "url(#paint4_linear_922_23996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5417 25.8334C25.4658 25.8334 25.39 25.8042 25.3375 25.7459C25.2792 25.6934 25.25 25.6175 25.25 25.5417C25.25 25.4659 25.2792 25.39 25.3375 25.3375C25.4425 25.2267 25.6408 25.2267 25.7458 25.3375C25.8042 25.3959 25.8333 25.4659 25.8333 25.5417C25.8333 25.6175 25.8042 25.6934 25.7517 25.7459C25.6933 25.8042 25.6175 25.8334 25.5417 25.8334Z",
    fill: "url(#paint5_radial_922_23996)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_922_23996",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_922_23996",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_922_23996",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCBBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F3FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_922_23996",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCBCF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_922_23996",
    x1: 20,
    y1: 13,
    x2: 20,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_922_23996",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(7 7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDBDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F2FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/geofence.e3929d90aced9c150e22bd6e695a666b.svg";
export { ForwardRef as ReactComponent };